import React from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Typography } from '@material-ui/core';
import { useStyles } from './styles';
import { IOccupation } from 'realhaus-sdk';
import { IncomeCard } from '../income/incomeCard';

interface FinancialsProps {
    occupations?: IOccupation[];
}

export const FinancialsComponent: React.FC<FinancialsProps> = observer(({ occupations }) => {
    const classes = useStyles();

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography
                        variant='h6'
                        component='h6'
                        gutterBottom
                        style={{ textTransform: 'uppercase' }}
                    >
                        Employment History
                    </Typography>
                    <Grid container spacing={2}>
                        {occupations &&
                            occupations.length >= 1 &&
                            occupations.map((occ) => (
                                <Grid item xs={12} className={classes.gutterBottom}>
                                    <IncomeCard occupation={occ} />
                                </Grid>
                            ))}
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
});
